import { useEffect } from "react";

// Хук для обробки кліків поза компонентом
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      // Ігноруємо клік, якщо він всередині ref-елемента
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };

    document.addEventListener("mousedown", listener);
    // Прибираємо слухача при демонтуванні компонента
    return () => document.removeEventListener("mousedown", listener);
  }, [ref, handler]);
};

export default useClickOutside;
